import 'reflect-metadata';
import './polyfills';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { container, IocProvider } from '@vk-hr-tek/core/ioc';
import { monitoringInit } from '@vk-hr-tek/core/monitoring/monitoringInit';

import { createStore } from '@app/store';

import { serviceWorkerRegister } from './serviceWorkerRegister';
import App from './App';

const { store, injectReducer } = createStore();
monitoringInit();

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <IocProvider container={container}>
      <App injectReducer={injectReducer} />
    </IocProvider>
  </Provider>,
);

serviceWorkerRegister();
